<mat-card style="width: 90%; height: 90%;" class=card>
	<button style="width: 100%; height: 100%;" class="button mat-elevation-z0" (click)="this.clicked()">
		<div fxLayout="column" class=mat-elevation-z0>
			<div fxFlex=50 class=icon-container>
					<mat-icon fontSet="material-icons-outlined" class=main-icon>{{this.icon}}</mat-icon>
			</div>
			<div fxFlex=50 class=text>
				{{this.text}}
			</div>
		</div>
	</button>
</mat-card>
